export enum ViewScope {

    ORGANIZATION    = 1,    // any / generic report
    PROJECT         = 2,
    USER            = 3     // not in use yet
    // personal ? = my work hhhmmm interesting
    // workspace ?
    // what else ?


}